import { Navigate, useParams } from 'react-router-dom';

const RedirectToTerms: React.FC = () => {
  const { lang } = useParams<{ lang: string }>();
  return <Navigate to={`/${lang || 'fr'}/terms`} replace />;
};

export default RedirectToTerms;
